import React, { Component } from "react";
import "./style.css";
import "../../../index.css";
/**
 * 这是通用的搜索框
 */
class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      placeholder,
      handleVisibleFilter,
      visible,
      name
    } = this.props;
    return (
      <div
        className={visible === true ? "search_box" : "search_box display_none"}
      >
        <div className="search_box_left fl">
          <div className="search_box_left_div">
            <div className="search_box_left_div_img fl">
              <img
                alt=""
                src={require("../../../images/search/search_2.png")}
              ></img>
            </div>
            <div className="search_box_left_div_input fl">
              <input
                onClick={this.handleVisibleSearch}
                placeholder={placeholder}
                value={name}
                readOnly
              ></input>
            </div>
          </div>
        </div>
        <div onClick={handleVisibleFilter} className="search_box_right fl">
          <div className="search_box_right_img fl">
            <img
              alt=""
              src={require("../../../images/search/search_1.png")}
            ></img>
          </div>
          <div className="search_box_right_txt fl">筛选</div>
        </div>
        <div className="clear"></div>
      </div>
    );
  }
  handleVisibleSearch = () => {
    this.props.handleVisibleSearch();
    this.props.handleCloseDataList();
  };
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/Search/SearchBox/index.js